import React, { Component } from 'react';
import { Link } from 'react-router';
import firebase from 'firebase';

class Modal extends Component {
  constructor () {
    super()
    this.handleDeleteBook = this.handleDeleteBook.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this.booksRef = this.booksRef.bind(this);
  }

  booksRef () {
    return firebase.database().ref(`books`);
  }

  handleDeleteBook (key) {
    console.log(key);
    // const self = this;
    this.booksRef().child(`${key}`).remove().then(() => {
      console.log('Book deleted');
      this.props.clearSearch();
      this.props.closeModal();
    }).catch(err => {
      console.log('Error Deleting from the Database', err);
    })
  }

  saveChanges (e) {
    e.preventDefault();
    let keywordArray;
    if (this.refs.keywords.value.trim() === "") {
      keywordArray = 0;
    } else if (this.refs.keywords.value === this.props.book.Keywords) {
      keywordArray = this.props.book.Keywords;
    } else {
      keywordArray = this.refs.keywords.value.split(',').map(kw => {
        return kw.trim();
      });
    }
    let book = {
      Author: this.refs.author.value || this.props.book.Author,
      Class: this.refs.class.value || this.props.book.Class,
      Date: this.refs.date.value || this.props.book.Date,
      Keywords: keywordArray,
      Ref: this.refs.ref.value || this.props.book.Ref,
      Title: this.refs.title.value || this.props.book.Title,
      key: this.props.book.key,
      pages: this.props.book.pages
    }
    this.props.editBook(book);
  }

  render() {
    let keywordComponents,
        defaultKeywordValue;
    if (this.props.book.Keywords === 0) {
      defaultKeywordValue = "";
    } else {
      defaultKeywordValue = this.props.book.Keywords;
    }
    if (this.props.book.Keywords !== 0 && this.props.book.Keywords.length > 0) {
      keywordComponents = this.props.book.Keywords.map((keyword, index) => {
        let path = `/keywords/${keyword}`;
        return <Link to={path} key={index} className="btn btn-xs btn-default keyword-button" >{keyword}</Link>
      });
    }
    const viewModal = (
      <div className="modal" style={{display:"block", backgroundColor: "rgba(19,19,19,0.9)"}}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.props.closeModal}>&times;</button>
              <h4 className="modal-title">{this.props.book.Title}</h4>
            </div>
            <div className="modal-body">
              <p>Author: {this.props.book.Author}</p>
              <p>Date: {this.props.book.Date}</p>
              <p>Ref: {this.props.book.Ref}</p>
              <p>Class: {this.props.book.Class}</p>
              <p>Keywords: {keywordComponents || 'No Keywords Currently Set'}</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal" onClick={this.props.closeModal}>Close</button>
            </div>
          </div>
        </div>
      </div>
    );
    const editModal = (
      <div className="modal" style={{display:"block", backgroundColor: "rgba(19,19,19,0.9)"}}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-hidden="true" onClick={this.props.closeModal}>&times;</button>
              <h4 className="modal-title">Edit Book</h4>
            </div>
            <div className="modal-body">
              <form className="form clearfix" onSubmit={this.saveChanges}>
                <div className="form-group">
                  <label>Title: </label>
                  <input type="text" className="form-control" ref="title" defaultValue={this.props.book.Title} />
                </div>
                <div className="form-group">
                  <label>Author: </label>
                  <input type="text" className="form-control" ref="author" defaultValue={this.props.book.Author} />
                </div>
                <div className="row">
                  <div className="form-group col-xs-6 col-md-4">
                    <label>Date: </label>
                    <input type="text" className="form-control" ref="date" defaultValue={this.props.book.Date} />
                  </div>
                  <div className="form-group col-xs-6 col-md-4">
                    <label>Ref: </label>
                    <input type="text" className="form-control" ref="ref" defaultValue={this.props.book.Ref} />
                  </div>
                  <div className="form-group col-xs-6 col-md-4">
                    <label>Class: </label>
                    <input type="text" className="form-control" ref="class" defaultValue={this.props.book.Class} />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-xs-12">
                    <label>Keywords: </label>
                    <input type="text" className="form-control" ref="keywords" defaultValue={defaultKeywordValue} />
                    <span className="help-block">comma separated list</span>
                  </div>
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-xs btn-danger pull-left" data-dismiss="modal" onClick={() => {this.handleDeleteBook(this.props.book.key)}}>Delete Book</button>
                  <button type="button" className="btn btn-default" data-dismiss="modal" onClick={this.props.closeModal}>Close</button>
                  <input type="submit" className="btn btn-warning" value="Save changes" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
    if (this.props.user) {
      return editModal;
    }
    return viewModal;
  }
}

export default Modal;



/** WEBPACK FOOTER **
 ** ./src/components/Books/Modal.js
 **/